import { useEffect } from 'react';
import Table from '@mui/material/Table';
import { useSelector, useDispatch, connect } from 'react-redux';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { getReportes } from '../../../store/fuse/reportes';
import { WrapperResult, WrapperButton } from './styles';
import ExportCSV from "../export_report/Export";
import ExportPdfDocument from "../export_report/Export_PDF";

const Index = (props) => {
  const dispatch = useDispatch();
  const initReportes = () => dispatch(getReportes());
  const reportesData = useSelector((state) => state.fuse?.reportes?.reportes?.data) || {};
  const searchReport = useSelector((state) => state.fuse?.reportes?.reportes?.data);
  // const filtersSelected = useSelector((state) => state?.fuse?.reportes?.filtersSelected);
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const { initDateSelected, endDateSelected } = props;

  const reportesSize = Object.keys(reportesData).length;

  const filtersSelected = { initDateSelected, endDateSelected };

  useEffect(() => {
    initReportes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WrapperResult>
      <div
        className="w-full flex flex-col justify-around rounded-lg mt-0 p-20 section-table"
        style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
      >
        <strong> Resultados de la Búsqueda :</strong>
        <TableContainer component={Paper} sx={{ height: '600px' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            {reportesSize >= 1 ? (
              <>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ID</TableCell>
                    <TableCell align="left">Reporte</TableCell>
                    <TableCell align="left">Excel</TableCell>
                    {/* <TableCell align="left">PDF</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportesData?.map((data, index) => (
                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="left">{index + 1}</TableCell>
                      <TableCell align="left">{data.name}</TableCell>
                      <TableCell align="left">
                        {' '}
                        <ExportCSV fileName={`${data.name}`} filters={filtersSelected} />
                      </TableCell>
                      {/* <TableCell align="left">
                        {' '}
                        <ExportPdfDocument fileName={`${data.name}`}/>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </>
            ) : (
              <div className="not-report">
                <strong> No hay reportes que mostrar</strong>
              </div>
            )}
          </Table>
        </TableContainer>
        {reportesSize === 1 && (
          <WrapperButton>
            <Button variant="contained" color="primary" onClick={() => initReportes()}>
              Borrar Búsqueda
            </Button>
          </WrapperButton>
        )}
      </div>
    </WrapperResult>
  );
};

const mapStateToProps = (state) => ({
  reportes: state?.reportes?.reportes?.data,
});

export default connect(mapStateToProps)(Index);
